import { useContext } from 'react';

import {
  BpkFlex,
  BpkSpacing,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';

import StringsContext from '../Contexts/StringsContext';
import { BOARD_TYPE } from '../server/constants';

import type { Board } from '../ArrivalsDeparturesBoardReducer';

import STYLES from './Heading.module.scss';

interface Props {
  selectedBoard: Board;
}

const Heading = ({ selectedBoard }: Props) => {
  const strings = useContext(StringsContext);
  const isArrivals = selectedBoard === BOARD_TYPE.ARRIVALS;

  return (
    <BpkVessel as="div" className={STYLES.Heading}>
      <BpkFlex padding={BpkSpacing.MD} gap={BpkSpacing.MD}>
        <BpkFlex data-testid="heading-airline" minWidth="12rem" basis="16%">
          {strings.falcon_adb_column_airline}
        </BpkFlex>
        <BpkFlex data-testid="heading-flight-code" minWidth="6rem" basis="11%">
          {strings.falcon_adb_column_flight_code}
        </BpkFlex>
        <BpkFlex
          data-testid="heading-arrival-departure-time"
          minWidth="6rem"
          basis="10%"
        >
          {isArrivals
            ? strings.falcon_adb_column_arrival_time
            : strings.falcon_adb_column_departure_time}
        </BpkFlex>
        <BpkFlex data-testid="heading-origin-destination" grow={1}>
          {isArrivals
            ? strings.falcon_adb_column_origin
            : strings.falcon_adb_column_destination}
        </BpkFlex>
        <BpkFlex data-testid="heading-status">
          {strings.falcon_adb_column_status}
        </BpkFlex>
        <BpkFlex
          data-testid="heading-terminal-and-gate"
          minWidth="6rem"
          basis="13%"
          justify="flex-end"
        >
          <BpkVessel as="div" className={STYLES.Heading__terminalAndGate}>
            {strings.falcon_adb_column_terminal_and_gate}
          </BpkVessel>
        </BpkFlex>
      </BpkFlex>
    </BpkVessel>
  );
};

export default Heading;
